/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Auth API
 * API для аутентификации и авторизации
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { authKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType, type BodyType } from '../../shared/api/kyMutator';
import {
    type GetAuthMeParams,
    type InternalApiHttpAuthEnrollTelegramRequest,
    type InternalApiHttpAuthEnrollTelegramResponse,
    type InternalApiHttpAuthErrorResponse,
    type InternalApiHttpAuthGetMeResponse,
    type InternalApiHttpAuthLoginRequest,
    type InternalApiHttpAuthLoginResponse,
    type InternalApiHttpAuthPasswordResetRequest,
    type InternalApiHttpAuthPasswordSetRequest,
    type InternalApiHttpAuthRefreshResponse,
    type InternalApiHttpAuthSignupRequest,
    type PostAuthLoginParams,
    type PostAuthSignupParams,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };

    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') {
            continue;
        }

        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }

    return result;
};

export const getPostAuthEnrollTelegramUrl = () => {
    return '/auth/enroll/telegram';
};

/**
 * Выполняет вход через telegram, возвращает access и refresh токены
 * @summary Вход через telegram
 */
export const postAuthEnrollTelegram = async (
    internalApiHttpAuthEnrollTelegramRequest: InternalApiHttpAuthEnrollTelegramRequest,
    options?: Parameters<typeof authKyMutator>[1],
): Promise<InternalApiHttpAuthEnrollTelegramResponse> => {
    return authKyMutator<InternalApiHttpAuthEnrollTelegramResponse>(getPostAuthEnrollTelegramUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthEnrollTelegramRequest),
    });
};

export const getPostAuthEnrollTelegramQueryKey = (
    internalApiHttpAuthEnrollTelegramRequest?: BodyType<InternalApiHttpAuthEnrollTelegramRequest>,
) => {
    return ['POST', '/auth/enroll/telegram', internalApiHttpAuthEnrollTelegramRequest] as const;
};

export const getPostAuthEnrollTelegramQueryOptions = <
    TData = Awaited<ReturnType<typeof postAuthEnrollTelegram>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthEnrollTelegramRequest: BodyType<InternalApiHttpAuthEnrollTelegramRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthEnrollTelegram>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getPostAuthEnrollTelegramQueryKey(internalApiHttpAuthEnrollTelegramRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof postAuthEnrollTelegram>>> = ({ signal }) =>
        postAuthEnrollTelegram(internalApiHttpAuthEnrollTelegramRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof postAuthEnrollTelegram>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostAuthEnrollTelegramQueryResult = NonNullable<Awaited<ReturnType<typeof postAuthEnrollTelegram>>>;
export type PostAuthEnrollTelegramQueryError = ErrorType<InternalApiHttpAuthErrorResponse>;

export function usePostAuthEnrollTelegram<
    TData = Awaited<ReturnType<typeof postAuthEnrollTelegram>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthEnrollTelegramRequest: BodyType<InternalApiHttpAuthEnrollTelegramRequest>,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthEnrollTelegram>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthEnrollTelegram>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthEnrollTelegram>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthEnrollTelegram<
    TData = Awaited<ReturnType<typeof postAuthEnrollTelegram>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthEnrollTelegramRequest: BodyType<InternalApiHttpAuthEnrollTelegramRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthEnrollTelegram>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthEnrollTelegram>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthEnrollTelegram>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthEnrollTelegram<
    TData = Awaited<ReturnType<typeof postAuthEnrollTelegram>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthEnrollTelegramRequest: BodyType<InternalApiHttpAuthEnrollTelegramRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthEnrollTelegram>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Вход через telegram
 */

export function usePostAuthEnrollTelegram<
    TData = Awaited<ReturnType<typeof postAuthEnrollTelegram>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthEnrollTelegramRequest: BodyType<InternalApiHttpAuthEnrollTelegramRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthEnrollTelegram>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getPostAuthEnrollTelegramQueryOptions(internalApiHttpAuthEnrollTelegramRequest, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getPostAuthLoginUrl = (params?: PostAuthLoginParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/auth/login?${stringifiedParams}` : '/auth/login';
};

/**
 * Выполняет вход по email и паролю, возвращает access и refresh токены
 * @summary Авторизация пользователя
 */
export const postAuthLogin = async (
    internalApiHttpAuthLoginRequest: InternalApiHttpAuthLoginRequest,
    params?: PostAuthLoginParams,
    options?: Parameters<typeof authKyMutator>[1],
): Promise<InternalApiHttpAuthLoginResponse> => {
    return authKyMutator<InternalApiHttpAuthLoginResponse>(getPostAuthLoginUrl(params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthLoginRequest),
    });
};

export const getPostAuthLoginQueryKey = (
    internalApiHttpAuthLoginRequest?: BodyType<InternalApiHttpAuthLoginRequest>,
    params?: PostAuthLoginParams,
) => {
    return ['POST', '/auth/login', ...(params ? [params] : []), internalApiHttpAuthLoginRequest] as const;
};

export const getPostAuthLoginQueryOptions = <
    TData = Awaited<ReturnType<typeof postAuthLogin>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthLoginRequest: BodyType<InternalApiHttpAuthLoginRequest>,
    params?: PostAuthLoginParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getPostAuthLoginQueryKey(internalApiHttpAuthLoginRequest, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof postAuthLogin>>> = ({ signal }) =>
        postAuthLogin(internalApiHttpAuthLoginRequest, params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof postAuthLogin>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostAuthLoginQueryResult = NonNullable<Awaited<ReturnType<typeof postAuthLogin>>>;
export type PostAuthLoginQueryError = ErrorType<InternalApiHttpAuthErrorResponse>;

export function usePostAuthLogin<
    TData = Awaited<ReturnType<typeof postAuthLogin>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthLoginRequest: BodyType<InternalApiHttpAuthLoginRequest>,
    params: undefined | PostAuthLoginParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthLogin>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthLogin>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthLogin<
    TData = Awaited<ReturnType<typeof postAuthLogin>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthLoginRequest: BodyType<InternalApiHttpAuthLoginRequest>,
    params?: PostAuthLoginParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthLogin>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthLogin>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthLogin<
    TData = Awaited<ReturnType<typeof postAuthLogin>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthLoginRequest: BodyType<InternalApiHttpAuthLoginRequest>,
    params?: PostAuthLoginParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Авторизация пользователя
 */

export function usePostAuthLogin<
    TData = Awaited<ReturnType<typeof postAuthLogin>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthLoginRequest: BodyType<InternalApiHttpAuthLoginRequest>,
    params?: PostAuthLoginParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getPostAuthLoginQueryOptions(internalApiHttpAuthLoginRequest, params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getPostAuthLogoutUrl = () => {
    return '/auth/logout';
};

/**
 * Удаляет refresh токен (cookie), инвалидирует сессию и завершает авторизацию
 * @summary Выход пользователя
 */
export const postAuthLogout = async (options?: Parameters<typeof authKyMutator>[1]): Promise<void> => {
    return authKyMutator<void>(getPostAuthLogoutUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getPostAuthLogoutQueryKey = () => {
    return ['POST', '/auth/logout'] as const;
};

export const getPostAuthLogoutQueryOptions = <
    TData = Awaited<ReturnType<typeof postAuthLogout>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError, TData>>;
    request?: SecondParameter<typeof authKyMutator>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getPostAuthLogoutQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof postAuthLogout>>> = ({ signal }) =>
        postAuthLogout({ signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof postAuthLogout>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostAuthLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof postAuthLogout>>>;
export type PostAuthLogoutQueryError = ErrorType<InternalApiHttpAuthErrorResponse>;

export function usePostAuthLogout<
    TData = Awaited<ReturnType<typeof postAuthLogout>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthLogout>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthLogout>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthLogout<
    TData = Awaited<ReturnType<typeof postAuthLogout>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthLogout>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthLogout>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthLogout<
    TData = Awaited<ReturnType<typeof postAuthLogout>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Выход пользователя
 */

export function usePostAuthLogout<
    TData = Awaited<ReturnType<typeof postAuthLogout>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getPostAuthLogoutQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAuthMeUrl = (params?: GetAuthMeParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/auth/me?${stringifiedParams}` : '/auth/me';
};

/**
 * Проверяет валидность access токена и возвращает данные пользователя (ID и роли)
 * @summary Проверка валидности access токена и получения базовых данных пользователя
 */
export const getAuthMe = async (
    params?: GetAuthMeParams,
    options?: Parameters<typeof authKyMutator>[1],
): Promise<InternalApiHttpAuthGetMeResponse> => {
    return authKyMutator<InternalApiHttpAuthGetMeResponse>(getGetAuthMeUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetAuthMeQueryKey = (params?: GetAuthMeParams) => {
    return ['/auth/me', ...(params ? [params] : [])] as const;
};

export const getGetAuthMeQueryOptions = <
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params?: GetAuthMeParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAuthMeQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMe>>> = ({ signal }) =>
        getAuthMe(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getAuthMe>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMe>>>;
export type GetAuthMeQueryError = ErrorType<InternalApiHttpAuthErrorResponse>;

export function useGetAuthMe<
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params: undefined | GetAuthMeParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getAuthMe>>,
                    TError,
                    Awaited<ReturnType<typeof getAuthMe>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAuthMe<
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params?: GetAuthMeParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getAuthMe>>,
                    TError,
                    Awaited<ReturnType<typeof getAuthMe>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAuthMe<
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params?: GetAuthMeParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Проверка валидности access токена и получения базовых данных пользователя
 */

export function useGetAuthMe<
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params?: GetAuthMeParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetAuthMeQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getPatchAuthPasswordUrl = () => {
    return '/auth/password';
};

/**
 * Устанавливает новый пароль
 * @summary Установка нового пароля
 */
export const patchAuthPassword = async (
    internalApiHttpAuthPasswordSetRequest: InternalApiHttpAuthPasswordSetRequest,
    options?: Parameters<typeof authKyMutator>[1],
): Promise<void> => {
    return authKyMutator<void>(getPatchAuthPasswordUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthPasswordSetRequest),
    });
};

export const getPatchAuthPasswordQueryKey = (
    internalApiHttpAuthPasswordSetRequest?: BodyType<InternalApiHttpAuthPasswordSetRequest>,
) => {
    return ['PATCH', '/auth/password', internalApiHttpAuthPasswordSetRequest] as const;
};

export const getPatchAuthPasswordQueryOptions = <
    TData = Awaited<ReturnType<typeof patchAuthPassword>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordSetRequest: BodyType<InternalApiHttpAuthPasswordSetRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof patchAuthPassword>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getPatchAuthPasswordQueryKey(internalApiHttpAuthPasswordSetRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patchAuthPassword>>> = ({ signal }) =>
        patchAuthPassword(internalApiHttpAuthPasswordSetRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof patchAuthPassword>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PatchAuthPasswordQueryResult = NonNullable<Awaited<ReturnType<typeof patchAuthPassword>>>;
export type PatchAuthPasswordQueryError = ErrorType<InternalApiHttpAuthErrorResponse>;

export function usePatchAuthPassword<
    TData = Awaited<ReturnType<typeof patchAuthPassword>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordSetRequest: BodyType<InternalApiHttpAuthPasswordSetRequest>,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof patchAuthPassword>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof patchAuthPassword>>,
                    TError,
                    Awaited<ReturnType<typeof patchAuthPassword>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePatchAuthPassword<
    TData = Awaited<ReturnType<typeof patchAuthPassword>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordSetRequest: BodyType<InternalApiHttpAuthPasswordSetRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof patchAuthPassword>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof patchAuthPassword>>,
                    TError,
                    Awaited<ReturnType<typeof patchAuthPassword>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePatchAuthPassword<
    TData = Awaited<ReturnType<typeof patchAuthPassword>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordSetRequest: BodyType<InternalApiHttpAuthPasswordSetRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof patchAuthPassword>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Установка нового пароля
 */

export function usePatchAuthPassword<
    TData = Awaited<ReturnType<typeof patchAuthPassword>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordSetRequest: BodyType<InternalApiHttpAuthPasswordSetRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof patchAuthPassword>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getPatchAuthPasswordQueryOptions(internalApiHttpAuthPasswordSetRequest, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getPostAuthPasswordResetUrl = () => {
    return '/auth/password/reset';
};

/**
 * Отправляет код для восстановления аккаунта
 * @summary Восстановление аккаунта пользователя
 */
export const postAuthPasswordReset = async (
    internalApiHttpAuthPasswordResetRequest: InternalApiHttpAuthPasswordResetRequest,
    options?: Parameters<typeof authKyMutator>[1],
): Promise<void> => {
    return authKyMutator<void>(getPostAuthPasswordResetUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthPasswordResetRequest),
    });
};

export const getPostAuthPasswordResetQueryKey = (
    internalApiHttpAuthPasswordResetRequest?: BodyType<InternalApiHttpAuthPasswordResetRequest>,
) => {
    return ['POST', '/auth/password/reset', internalApiHttpAuthPasswordResetRequest] as const;
};

export const getPostAuthPasswordResetQueryOptions = <
    TData = Awaited<ReturnType<typeof postAuthPasswordReset>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordResetRequest: BodyType<InternalApiHttpAuthPasswordResetRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthPasswordReset>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getPostAuthPasswordResetQueryKey(internalApiHttpAuthPasswordResetRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof postAuthPasswordReset>>> = ({ signal }) =>
        postAuthPasswordReset(internalApiHttpAuthPasswordResetRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof postAuthPasswordReset>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostAuthPasswordResetQueryResult = NonNullable<Awaited<ReturnType<typeof postAuthPasswordReset>>>;
export type PostAuthPasswordResetQueryError = ErrorType<InternalApiHttpAuthErrorResponse>;

export function usePostAuthPasswordReset<
    TData = Awaited<ReturnType<typeof postAuthPasswordReset>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordResetRequest: BodyType<InternalApiHttpAuthPasswordResetRequest>,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthPasswordReset>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthPasswordReset>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthPasswordReset>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthPasswordReset<
    TData = Awaited<ReturnType<typeof postAuthPasswordReset>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordResetRequest: BodyType<InternalApiHttpAuthPasswordResetRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthPasswordReset>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthPasswordReset>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthPasswordReset>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthPasswordReset<
    TData = Awaited<ReturnType<typeof postAuthPasswordReset>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordResetRequest: BodyType<InternalApiHttpAuthPasswordResetRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthPasswordReset>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Восстановление аккаунта пользователя
 */

export function usePostAuthPasswordReset<
    TData = Awaited<ReturnType<typeof postAuthPasswordReset>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthPasswordResetRequest: BodyType<InternalApiHttpAuthPasswordResetRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthPasswordReset>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getPostAuthPasswordResetQueryOptions(internalApiHttpAuthPasswordResetRequest, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getPostAuthRefreshUrl = () => {
    return '/auth/refresh';
};

/**
 * Получает refresh токен из cookie, выдает новый access токен и обновляет refresh токен
 * @summary Обновление токенов
 */
export const postAuthRefresh = async (
    options?: Parameters<typeof authKyMutator>[1],
): Promise<InternalApiHttpAuthRefreshResponse> => {
    return authKyMutator<InternalApiHttpAuthRefreshResponse>(getPostAuthRefreshUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getPostAuthRefreshQueryKey = () => {
    return ['POST', '/auth/refresh'] as const;
};

export const getPostAuthRefreshQueryOptions = <
    TData = Awaited<ReturnType<typeof postAuthRefresh>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError, TData>>;
    request?: SecondParameter<typeof authKyMutator>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getPostAuthRefreshQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof postAuthRefresh>>> = ({ signal }) =>
        postAuthRefresh({ signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof postAuthRefresh>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostAuthRefreshQueryResult = NonNullable<Awaited<ReturnType<typeof postAuthRefresh>>>;
export type PostAuthRefreshQueryError = ErrorType<InternalApiHttpAuthErrorResponse>;

export function usePostAuthRefresh<
    TData = Awaited<ReturnType<typeof postAuthRefresh>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthRefresh>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthRefresh>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthRefresh<
    TData = Awaited<ReturnType<typeof postAuthRefresh>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthRefresh>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthRefresh>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthRefresh<
    TData = Awaited<ReturnType<typeof postAuthRefresh>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Обновление токенов
 */

export function usePostAuthRefresh<
    TData = Awaited<ReturnType<typeof postAuthRefresh>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getPostAuthRefreshQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getPostAuthSignupUrl = (params?: PostAuthSignupParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/auth/signup?${stringifiedParams}` : '/auth/signup';
};

/**
 * Создает нового пользователя. Если передан password, сразу возвращает данные пользователя; иначе отправляет письмо для установки пароля
 * @summary Регистрация пользователя
 */
export const postAuthSignup = async (
    internalApiHttpAuthSignupRequest: InternalApiHttpAuthSignupRequest,
    params?: PostAuthSignupParams,
    options?: Parameters<typeof authKyMutator>[1],
): Promise<InternalApiHttpAuthGetMeResponse | void> => {
    return authKyMutator<InternalApiHttpAuthGetMeResponse | void>(getPostAuthSignupUrl(params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthSignupRequest),
    });
};

export const getPostAuthSignupQueryKey = (
    internalApiHttpAuthSignupRequest?: BodyType<InternalApiHttpAuthSignupRequest>,
    params?: PostAuthSignupParams,
) => {
    return ['POST', '/auth/signup', ...(params ? [params] : []), internalApiHttpAuthSignupRequest] as const;
};

export const getPostAuthSignupQueryOptions = <
    TData = Awaited<ReturnType<typeof postAuthSignup>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthSignupRequest: BodyType<InternalApiHttpAuthSignupRequest>,
    params?: PostAuthSignupParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthSignup>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getPostAuthSignupQueryKey(internalApiHttpAuthSignupRequest, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof postAuthSignup>>> = ({ signal }) =>
        postAuthSignup(internalApiHttpAuthSignupRequest, params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof postAuthSignup>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostAuthSignupQueryResult = NonNullable<Awaited<ReturnType<typeof postAuthSignup>>>;
export type PostAuthSignupQueryError = ErrorType<InternalApiHttpAuthErrorResponse>;

export function usePostAuthSignup<
    TData = Awaited<ReturnType<typeof postAuthSignup>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthSignupRequest: BodyType<InternalApiHttpAuthSignupRequest>,
    params: undefined | PostAuthSignupParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthSignup>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthSignup>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthSignup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthSignup<
    TData = Awaited<ReturnType<typeof postAuthSignup>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthSignupRequest: BodyType<InternalApiHttpAuthSignupRequest>,
    params?: PostAuthSignupParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthSignup>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postAuthSignup>>,
                    TError,
                    Awaited<ReturnType<typeof postAuthSignup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePostAuthSignup<
    TData = Awaited<ReturnType<typeof postAuthSignup>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthSignupRequest: BodyType<InternalApiHttpAuthSignupRequest>,
    params?: PostAuthSignupParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthSignup>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Регистрация пользователя
 */

export function usePostAuthSignup<
    TData = Awaited<ReturnType<typeof postAuthSignup>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    internalApiHttpAuthSignupRequest: BodyType<InternalApiHttpAuthSignupRequest>,
    params?: PostAuthSignupParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof postAuthSignup>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getPostAuthSignupQueryOptions(internalApiHttpAuthSignupRequest, params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
